import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { accessLocalStorage, readAllTenant, exportSelectAllMohs, exportDeleteMohs } from '../../../services';

import PbxContext from '../../../context/PbxContext';
import Loading from '../../../components/Loading/LoadingModule';
import './MohList.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash, faEye, faPlus, faMusic } from '@fortawesome/free-solid-svg-icons';

function MohList() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsHidden, toggleIsChangeFormElements, setItemsSelectedToEdit } = getItensStateGlobal;

  const [loading, setLoading] = useState(true);
  const [mohs, setMohs] = useState([]);
  const [allMohs, setAllMohs] = useState([]);
  const [tenants, setTenants] = useState([]);
  const [tenantFilter, setTenantFilter] = useState("");
  const [selectedMoh, setSelectedMoh] = useState(null);
  const [mohSelected, setMohSelected] = useState([]);
  const [disable, setDisable] = useState(true);

  const history = useHistory();

  const fetchMohs = async (idtenant) => {
    try {
      const response = await exportSelectAllMohs();
      if (response && response.status === 200 && response.data) {
        // Filtrar os dados com base no idtenant
        let filteredMohs = response.data;
        if (idtenant && !idtenant.includes('vgs')) {
          // Se o usuário não for 'vgs', filtramos apenas por seu tenant
          filteredMohs = response.data.filter((moh) => idtenant.includes(moh.accountcode));
        }
        
        setAllMohs(filteredMohs);
        setMohs(filteredMohs);
      } else {
        setLoading(true)
        console.error("Erro ao buscar músicas de espera:", response);
      }
    } catch (error) {
      console.error("Exceção ao buscar músicas de espera:", error);
    }
  };

  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    if (!dataUser) return history.push('/');
    
    const { user: { role, idtenant } } = dataUser;
    if (dataUser && role !== 'root') return history.push('/home');

    let tenantsFetched = await readAllTenant();
    tenantsFetched = idtenant.includes('vgs') ? tenantsFetched : tenantsFetched.filter((tenant) => idtenant.includes(tenant.short_name));
    
    if (!tenantsFetched) return;
    setTenants(tenantsFetched);
    
    await fetchMohs(idtenant);
    setLoading(false);
  }, [history]);

  const handleChangeSelectedMohs = (mohName) => {
    setMohSelected(mohName);
  };

  const handleClickDelete = () => {
    toggleIsHidden('#alert-confirm-moh-delete');
    setSelectedMoh(mohSelected);
    setDisable(false);
  };

  const confirmDelete = async () => {
    try {
      toggleIsHidden('#alert-confirm-moh-delete');
      toggleIsChangeFormElements('alert-success-deletion', 'column is-half is-offset-one-quarter message is-success is-active');
      await exportDeleteMohs(selectedMoh);
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } catch (error) {
      console.error("Erro ao excluir músicas de espera:", error);
      toggleIsHidden('#alert-confirm-moh-delete');
      toggleIsChangeFormElements('alert-error-deletion', 'column is-half is-offset-one-quarter message is-danger is-active');
    }
  };

  const handleClickUpdate = () => {
      setItemsSelectedToEdit(mohSelected);
      history.push('/config/musica-de-espera/editar');
  };

  const handleChangeSelectAll = () => {
    const inputSelectAll = document.getElementById('select-all');
    const selectMohs = mohs.map((element) => {
      const getCheckbox = document.getElementById(element.name);
      if(inputSelectAll.checked) {
        getCheckbox.checked = true;
        setDisable(false);
        return element.name;
      } else {
        getCheckbox.checked = false;
        setDisable(true);
        return null;
      }
    });
    const result = selectMohs[0] === null ? [] : selectMohs;
    return setMohSelected(result);
  };

  useEffect(() => {
    let cancel = false;
    
    if (cancel) return;
    validateUserLogged();

    return () => {
      cancel = true
    };
  }, [validateUserLogged]);

  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <div className="moh-list-container">
          <div className="moh-header">
            <div className="moh-title-wrapper">
              <div className="moh-title-left">
                <svg className="moh-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3" />
                </svg>
                <div>
                  <h1 className="moh-title">Músicas de Espera</h1>
                  <p className="moh-subtitle">Gerencie as músicas de espera do sistema</p>
                </div>
              </div>
              <div className="moh-actions">
                <Link to="/config/musica-de-espera/novo" className="btn-moh btn-new-moh">
                  <FontAwesomeIcon icon={faPlus} className="btn-icon" />
                  Nova Música
                </Link>
                <button 
                  className="btn-moh btn-edit-moh" 
                  disabled={mohSelected.length === 0} 
                  onClick={handleClickUpdate}
                >
                  <FontAwesomeIcon icon={faPen} className="btn-icon" />
                  Editar
                </button>
                <button 
                  className="btn-moh btn-delete-moh" 
                  disabled={mohSelected.length === 0} 
                  onClick={handleClickDelete}
                >
                  <FontAwesomeIcon icon={faTrash} className="btn-icon" />
                  Excluir
                </button>
              </div>
            </div>
          </div>

          <div className="alerts-section">
            <div id="alert-error-deletion" className="alert-message alert-danger is-hidden">
              <div className="alert-header">
                <span>Erro!</span>
                <button className="alert-close" aria-label="delete" onClick={() => toggleIsHidden('#alert-error-deletion')}>×</button>
              </div>
              <div className="alert-body">
                Não foi possível excluir as músicas de espera selecionadas.
              </div>
            </div>

            <div id="alert-success-deletion" className="alert-message alert-success is-hidden">
              <div className="alert-header">
                <span>Sucesso!</span>
                <button className="alert-close" aria-label="delete" onClick={() => toggleIsHidden('#alert-success-deletion')}>×</button>
              </div>
              <div className="alert-body">
                Músicas de espera excluídas com sucesso!
              </div>
            </div>

            <div id="alert-confirm-moh-delete" className="alert-message alert-danger is-hidden">
              <div className="alert-header">
                <span>Atenção!</span>
                <button className="alert-close" aria-label="delete" onClick={() => toggleIsHidden('#alert-confirm-moh-delete')}>×</button>
              </div>
              <div className="alert-body">
                Tem certeza que deseja excluir as músicas de espera selecionadas?
              </div>
              <div className="alert-actions">
                <button className="btn-alert btn-alert-confirm" onClick={confirmDelete}>
                  <FontAwesomeIcon icon={faTrash} />
                  Confirmar
                </button>
                <button className="btn-alert btn-alert-cancel" onClick={() => toggleIsHidden('#alert-confirm-moh-delete')}>
                  Cancelar
                </button>
              </div>
            </div>
          </div>

          <div className="moh-table-wrapper">
            <table className="moh-table">  
              <thead className="moh-table-header">
                <tr>
                  <th className="checkbox-cell"></th>
                  <th>Nome</th>
                  <th>Cliente</th>
                  <th>Modo</th>
                  <th>Ordenação</th>
                  <th>Arquivo/Diretório</th>
                </tr>
              </thead>
              <tbody>
              {mohs.length > 0 ? (
                mohs.filter((moh) => moh.name !== 'default').map((moh) => {
                  const { name, accountcode, mode, sort, directory, entry, created_at } = moh;
                  const displayPathFile = entry || directory ? (entry?.split('uploads')[1] || directory?.split('uploads')[1]) : '-';
                  return (
                    <tr key={name}>
                      <td className="checkbox-cell"><input name="moh-selected" id={name} type="radio" value={name} onClick={(e) => handleChangeSelectedMohs(e.target.value)}/></td>
                      <td>{name}</td>
                      <td>{accountcode}</td>
                      <td>{mode === 'files' ? 'Ler Pasta' : 'Música Única'}</td>
                      <td>{sort === 'name' ? 'Nome' : sort === 'random' ? 'Aleatório' : sort}</td>
                      <td>{displayPathFile}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="6" style={{textAlign: 'center'}}>Nenhuma música de espera encontrada</td>
                </tr>
              )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

export default MohList;